import React, { useCallback } from 'react'
import { Container } from 'react-bootstrap'
import { useFormContext } from 'react-hook-form'
import { MissingScopeAction } from '../../../../components/ScopedBlock/models'
import { ScopedBlock } from '../../../../components/ScopedBlock/ScopedBlock'
import { IntegrationServiceId, SALESFORCE_BASED_INTEGRATIONS } from '../../../../common/integrations'
import { IntegrationUrlInputField } from '../../../../components/Integrations/IntegrationUrlInputField'
import { IntegrationSettings } from '../AdminSettings/schema'
import { useGetIntegrationAdminSettings } from '../AdminSettings/hooks'

export interface IntegrationLoginURLSettingProps {
  serviceId: IntegrationServiceId
}

export const IntegrationLoginURLSetting: React.FC<IntegrationLoginURLSettingProps> = ({ serviceId }) => {
  const { watch, setValue } = useFormContext<IntegrationSettings>()

  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)
  const loginUrl = watch('loginUrl') ?? null
  const accountConfigIsCustom = watch('isCustom') ?? true

  const handleURLChange = useCallback(
    (url: string) => {
      setValue('loginUrl', url, { shouldDirty: true, shouldValidate: true })
    },
    [setValue],
  )

  if (isAccountFetching) {
    return (
      <Container>
        <div className='skeleton mb-2' style={{ width: '100%', height: '70px' }} />
        <div className='skeleton mb-3' style={{ width: '100%', height: '70px' }} />
      </Container>
    )
  }

  return (
    <Container>
      <div className='d-flex flex-column gap-5'>
        <div className='d-flex flex-column gap-2'>
          <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'account:update', superScope: ['account:admin'] }}>
            {SALESFORCE_BASED_INTEGRATIONS.includes(serviceId) && (
              <IntegrationUrlInputField
                label='CRM Login url (Optional):'
                tooltipText='Add your custom salesforce login URL. Make sure it starts with https://'
                placeholder='https://login.salesforce.com/'
                helperText='Keep it blank to use the default login url.'
                disabled={accountConfigIsCustom}
                value={loginUrl}
                onChange={handleURLChange}
              />
            )}

            {(serviceId === IntegrationServiceId.DYNAMICS || serviceId === IntegrationServiceId.ENGAGE) && (
              <IntegrationUrlInputField
                label='Dynamics custom URL (Optional):'
                tooltipText='Add your custom Dynamics URL. Make sure it starts with https://'
                placeholder='https://custom-domain.crm.dynamics.com'
                helperText='Keep it blank to use the default url.'
                disabled={accountConfigIsCustom}
                value={loginUrl}
                onChange={handleURLChange}
              />
            )}
          </ScopedBlock>
        </div>
      </div>
    </Container>
  )
}
